import React from 'react';
import { Check } from 'lucide-react';
import StepHeading from './StepHeading';

interface Step4Props {
  productImages: string[];
  selectedImages: string[];
  setSelectedImages: (images: string[]) => void;
  handleStep4: () => void;
  loading: boolean;
  isGeneratingImages: boolean;
}

const PLATE_LABELS = ['Studio', 'Lifestyle', 'Minimal', 'Editorial'];

const Step4: React.FC<Step4Props> = ({
  productImages,
  selectedImages,
  setSelectedImages,
  isGeneratingImages,
}) => {
  const toggle = (image: string) => {
    setSelectedImages(selectedImages.includes(image) ? [] : [image]);
  };

  return (
    <div className="ed-enter">
      <StepHeading
        index={4}
        kicker="Photography"
        title="Pick the frame that sells it."
        lede="Four renders, four points of view. Choose the one you would put on the storefront."
      />

      <div className="ed-block">
        <div className="ed-plates" role="radiogroup" aria-label="Product photography">
          {[0, 1, 2, 3].map((index) => {
            if (isGeneratingImages || !productImages[index]) {
              return (
                <div key={index} className="ed-skeleton ed-skeleton--plate">
                  Rendering {PLATE_LABELS[index]}
                </div>
              );
            }

            const src = productImages[index];
            const isSelected = selectedImages.includes(src);

            return (
              <div
                key={index}
                role="radio"
                aria-checked={isSelected}
                tabIndex={0}
                className={`ed-plate${isSelected ? ' is-selected' : ''}`}
                onClick={() => toggle(src)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggle(src);
                  }
                }}
              >
                <img
                  className="ed-plate-img"
                  src={src}
                  alt={`${PLATE_LABELS[index]} product render`}
                  draggable={false}
                />
                <div className="ed-plate-cap">
                  <span>
                    {String(index + 1).padStart(2, '0')} — {PLATE_LABELS[index]}
                  </span>
                  {isSelected && <Check aria-hidden="true" />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Step4;
